import React from 'react';
import Layout from '../../components/Layout';
import User from '../../domain/User';
import Color from '../../domain/Color';
import UserHeader from '../../components/header/User';
import PurchaseContent from '../../components/content/Purchase';
import Sponsor from '../../components/Sponsor';
import t from 'tcomb-form';
import { props } from 'tcomb-react';

@props({
  locale: t.Obj,
  purchase: t.Obj,
  pending_purchase_message: t.Str,
  user: User,
  goAccount: t.Func,
  goChangePassword: t.Func,
  goPurchases: t.Func,
  doLogout: t.Func,
  doAcceptCookies: t.Func,
  message: t.maybe(t.ReactElement),
  share_purchase: t.maybe(t.ReactElement),
  custom_payments: t.maybe(t.list(t.Obj)),
  themeBgColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  doSendGiftCardCode: t.Func
})
export default class Purchase extends React.Component {

  getHeader() {
    return (
      <UserHeader user={this.props.user}
          locale={this.props.locale}
          goAccount={this.props.goAccount}
          goChangePassword={this.props.goChangePassword}
          goPurchases={this.props.goPurchases}
          doLogout={this.props.doLogout} />
    );
  }

  getSponsor() {
    const options = {
      showTutorial: false
    };
    return (<Sponsor locale={this.props.locale} options={options} />);
  }
  render() {
    const { locale } = this.props;
    return (
      <Layout header={this.getHeader()} sponsor={this.getSponsor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
       <PurchaseContent
          locale={locale}
          purchase={this.props.purchase}
          pending_purchase_message={this.props.pending_purchase_message}
          user={this.props.user}
          goAccount={this.props.goAccount}
          goChangePassword={this.props.goChangePassword}
          goPurchases={this.props.goPurchases}
          doLogout={this.props.doLogout}
          doAcceptCookies={this.props.doAcceptCookies}
          message={this.props.message}
          share_purchase={this.props.share_purchase}
          custom_payments={this.props.custom_payments}
          themeBgColor={this.props.themeBgColor}
          themeBtnColor={this.props.themeBgColor}
          doSendGiftCardCode={this.props.doSendGiftCardCode} />
      </Layout>
    );
  }
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/user/route/Purchase.js
 **/